import React from "react";

import { localizer } from "../../../Translator";

import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Backdrop, CircularProgress } from "@material-ui/core"
import { Typography } from "@material-ui/core"
import { Button } from  "@material-ui/core"

import { MultiShipmentImageViewer } from "../../Utilities/MultiShipmentImageViewer"
import Roles from "../../Utilities/Roles"

import AuthCli from "../../../sdk/AuthCli";
import OutboxCli from "../../../sdk/OutboxCli";
import ProductCli from "../../../sdk/ProductCli";

export class ShipmentSavedSummary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,

      // Shipment object which feedback belong to
      shipment: {},
      shipmentId: null,

      // List of products availables for the user in session
      products: [],

      // Concatenation of the names of the draft documents that make up the final document of the shipment
      documentNames: [],

      // String errors to display in case of service calls go wrong
      feedbackShipmentError: null,
      feedbackShipmentDraftError: null,
      feedbackShipmentStatestError: null,
      downloadShipmentDocumentError: null,
      
      // Number of the current page which is displaying
      currentPage: 1,
      documentpages: [],

      // Base64 string that represent the content of draft document
      pageBase64: "",

      // String errors to display in case of service calls go wrong
      pageBase64Error: null,


      // Value of the price with format 
      priceFormat: ""
      
    }
  }

  /**
   * Component initialization. Filling state with the shipment and its associate information (drafts, feedbacks, etc)
   */
  componentDidMount() {

    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          this.getAllProducts()
          
          if (this.state.session.role === Roles.ROLE_USER.Name) {
            this.getShipmentByCode(this.props.shipmentCode)
            return
          }

          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getShipmentByCodeOfBillable(this.props.shipmentCode)
            return
          }
        })
      }
    })
  }

  // Getting list of product to visualize product description instead of productCode
  getAllProducts = () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  getShipmentByCode = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCode(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })
            
            this.getDocumentsOfShipment()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  getShipmentByCodeOfBillable = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCodeOfBillable(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })
            
            this.getDocumentsOfShipmentOfBillable()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  /**
   * Get documents and pages information to display the preview in the shipment summary for role USER
   */
  getDocumentsOfShipment = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraft(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }

  /**
   * Get documents and pages information to display the preview in the shipment summary for role ADMIN
   */
  getDocumentsOfShipmentOfBillable = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraftOfBillable(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }

 
  /**
   * download Shipment Document
   */
  downloadShipmentDocument = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocument(this.state.shipment.shipmentCode).then((error) => {
      this.setState({ isLoading: false })
      if (error) this.setState({ downloadShipmentDocumentError: error.substring(error.indexOf(' ')) })
      else this.setState({ downloadShipmentDocumentError: null })
    })
  }

  /**
   * Rereturning from the viewer to cancel the process wheel
   */
  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountSenderAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.senderAddress) return ""
    
    let senderAddress = this.state.shipment.senderAddress.who + "\n" +
      this.state.shipment.senderAddress.streetType + " " + this.state.shipment.senderAddress.streetName + " " + this.state.shipment.senderAddress.streetNumber + " " + this.state.shipment.senderAddress.streetComplements + "\n" +
      this.state.shipment.senderAddress.postalCode + " " + this.state.shipment.senderAddress.locality
    return senderAddress
  }

  getProductDescription = () => {
    let description = ""
    this.state.products && this.state.shipment.features && this.state.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  render() {

    return (
      <React.Fragment>
        <Dialog
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"xl"}
        >
          <DialogTitle id="alert-dialog-title" className="bg-primary" style={{ color: "black" }}>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.props.handleCloseModal}></i>
            <Grid container item md={12} justify="center">
              <Typography className="typography-generic large medium-weigh">{(this.state.shipment.features && this.state.shipment.features.reference) ? this.state.shipment.features.reference.toUpperCase() : ""}</Typography>
            </Grid>
            <Grid container item md={12} justify="center">
              <Typography className="typography-generic large bigweight">{localizer.InboxShipmentDetails + ": " + this.state.shipment.shipmentCode}</Typography>
            </Grid>
          </DialogTitle>
          <DialogContent dividers={true}>
            <Grid container direction="row" spacing={4}>
              <Grid item md={6} className="border-right-1-solid">
                <Grid container item md={12} className="mt-10">
                  <Typography className="typography-generic medium bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
                </Grid>
                <hr className="hr-custom"></hr>
                <Grid container item md={12} style={{ marginTop: '20px' }}>
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                  <Grid item md={7}><Typography className="typography-generic p-0">{this.getProductDescription()}</Typography></Grid>
                </Grid>
                <Grid container item md={12} style={{ marginTop: '20px' }}>
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxIncludedPages}:</Typography></Grid>
                  <Grid item md={7}>
                    {this.state.documentNames && this.state.documentNames.map((doc) => {
                        
                      return (<Typography key={doc} className="typography-generic shipment-summary-docnames p-0">{doc}</Typography>)
                    })}
                  </Grid>
                </Grid>
                <Grid container item md={12} style={{ marginTop: '20px' }}>
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxSender}:</Typography></Grid>
                  <Grid item md={7}>
                    <Typography className="typography-generic white-space-pre p-0" style={{ overflowX: "auto"}}>{this.mountSenderAddress()}</Typography>
                  </Grid>
                </Grid>
                <Grid container item md={12} style={{ marginTop: '20px' }}>
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxDestination}:</Typography></Grid>
                  <Grid item md={7}>
                    <Typography className="typography-generic white-space-pre p-0" style={{ overflowX: "auto"}}>{this.mountDestinationAddress()}</Typography>
                  </Grid>
                </Grid>
                <Grid container item md={12} className="mt-20">
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxPrintFeatures}:</Typography></Grid>
                  <Grid item md={7}><Typography className="typography-generic">{this.state.shipment.features ? (this.state.shipment.features.printColor ? "Color" : "B/N") + ", " + (this.state.shipment.features.printDuplex ? localizer.InboxDuplex : localizer.InboxSimplex) : ""}</Typography></Grid>
                </Grid>
                <Grid container item md={12} className="mt-20">
                  <Grid item md={5}><Typography className="typography-generic bigweight">{localizer.InboxPrice}:</Typography></Grid>
                  <Grid item md={7}><Typography className="typography-generic">{this.state.priceFormat}</Typography></Grid>
                </Grid>
                
              </Grid>

              {/* preview */}
              <Grid item md={6}>
                <Grid container item md={12} className="m-0">
                  <Grid container item justify="flex-start" md={6} alignItems="center">
                    <Typography className="typography-generic medium bigweight secondary">{localizer.InboxPreview}</Typography>
                  </Grid>
                  <Grid container item justify="flex-end" md={6} alignItems="center">
                    <Button className="button-generic primary mb-10" variant="contained" onClick={this.downloadShipmentDocument} startIcon={<i className="fa-solid fa-file-arrow-down"></i>}>
                      {localizer.Download}
                    </Button>
                  </Grid>
                </Grid>
                <hr className="hr-custom"></hr>
                <Grid container item md={12} className="p-2pc border-radius-20 mb-2_5pc mt-2_5pc">
                  <MultiShipmentImageViewer
                    shipmentId={this.state.shipmentId}
                    documentpages={this.state.documentpages}
                    pagenumber={this.state.currentPage}
                    viewerWidth={500}
                    viewerHeight={600}
                    handleisLoadingDraft={this.handleisLoadingDraft}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Waiting for service response. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}

export default ShipmentSavedSummary


// WEBPACK FOOTER //
// ./src/components/shipment-saved/sections/ShipmentSavedSummary.js